import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { ForeignActivitiesBenefitsModel } from './types';
import { foreignActivitiesBenefitItemValidator } from './validators/item';

const foreignActivitiesBenefitsValidator: ValidateJSModel<ForeignActivitiesBenefitsModel> = {
  HasBenefits: {
    hasValue: { validator: hasYesOrNo },
  },

  List: (value, attributes) => {
    if (attributes?.HasBenefits?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: foreignActivitiesBenefitItemValidator },
      };
    }

    return {};
  },
};
export default foreignActivitiesBenefitsValidator;
